
import React, { useEffect, useState, forwardRef, useRef } from "react";

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import {
    Box, Button, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';
import styles from '../../../styles.module.css';
import settings from '../../../images/settings_home2.jpg'
import CompanyDetailsList from "../companySetting/CompanyDetailsList";
import UserManagementList from "../userManagement/UserManagementList";
import MailsList from "../mails/MailsList";
import PrintSetup from "../print/PrintSetup";
import InvoicePrintTitleSetting from "../invoicePrintTitle/InvoicePrintTitleSetting";
import InvoiceSetting from "../invoiceSetting/InvoiceSetting";
import DocumentNumbringFormateList from "../documentFormat/DocumentNumbringFormateList";
import { Link } from "react-router-dom";
import Breadcrumb from "../../reusableComponent/Breadcrumb";

const CustomTab = styled(Tab)(({ theme }) => ({
    minWidth: '9px',
    minHeight: '8px',
    marginRight: '2px',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    padding: '4px 4px 4px 4px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function SettingsHome() {
    const [selectedTab, setSelectedTab] = useState(0);
    const [previousTabs, setPreviousTabs] = useState([]);

    const handleChangeTab = (event, newValue) => {
        setPreviousTabs((prev) => [...prev, selectedTab]); // Store the previous active tab
        setSelectedTab(newValue);
    };

    const handlePreviousTab = () => {
        if (previousTabs.length > 0) {
            const previousTab = previousTabs.pop();
            setSelectedTab(previousTab);
            setPreviousTabs([...previousTabs]); // Remove the last tab from the previousTabs array
        }
    };

    return (
        <>
         <Breadcrumb
                        routeSegments={[
                            { name: 'Settings', },
                        ]}
                    />
            <Paper className={`${styles.list_container}`}>
                <Grid container style={{ height: '420px', }}>
                    <Grid item xs={3} >
                        <List sx={{ width: '100%', display: 'inline-block' }}>
                            <>
                                <Link to="/company-details" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>CD</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="COMPANY DETAILS" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </Link>
                                <Link to="/user-management" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}> UM </Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="USERS MANAGEMENT" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </Link>
                                <Link to="/mail-setups" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>MS</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="MAIL SETUPS" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </Link>
                                <Link to="/print-setups" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>PS</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="PRINT SETUPS" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </Link>
                                <Link to="/invoice-print-title" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>IT</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="INVOICE PRINT TITLE" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </Link>
                                <Link to="/invoice-field-setting" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>IS</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="INVOICE FIELD SETTING" primaryTypographyProps={{ fontSize: '15px' }} />
                                    </ListItem>
                                </Link>
                                <Link to="/doc-no-format" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>DN</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="DOCUMENT NO FORMAT" primaryTypographyProps={{ fontSize: '15px', }} />
                                    </ListItem>
                                </Link>
                                <Link to="/menu-setting" className={`${styles.underline}`}>
                                    <ListItem className={`${styles.home_menu}`}>
                                        <ListItemAvatar>
                                            <Typography className={`${styles.menu_i}`}>MS</Typography>
                                        </ListItemAvatar>
                                        <ListItemText primary="MENU SETTING" primaryTypographyProps={{ fontSize: '15px', }} />
                                    </ListItem>
                                </Link>
                            </>
                        </List>
                    </Grid>
                </Grid>
            </Paper>
            {/* <Paper className={`${styles.list_container}`}>
                <Box sx={{ width: '100%', padding: '4px', paddingTop: '4px' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '32px', paddingLeft: '12px' }}>
                        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="basic tabs example"
                            indicatorColor="none"
                            textColor="#000000"
                            TabIndicatorProps={{
                                sx: { backgroundColor: "#ff6600", marginBottom: '17px' }
                            }}
                            variant="scrollable">
                            <CustomTab label={<HomeIcon />} {...a11yProps(0)} />
                            <CustomTab label="User Management" {...a11yProps(1)} />
                            <CustomTab label="Company Details" {...a11yProps(2)} />
                            <CustomTab label="Mail Setups" {...a11yProps(3)} />
                            <CustomTab label="Print Setups" {...a11yProps(4)} />
                            <CustomTab label="Invoice Print Title" {...a11yProps(5)} />
                            <CustomTab label="Invoice Fields Setting" {...a11yProps(6)} />
                            <CustomTab label="Document No Format" {...a11yProps(7)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                 
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <UserManagementList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                        <CompanyDetailsList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={3}>
                        <MailsList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={4}>
                        <PrintSetup handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={5}>
                        <InvoicePrintTitleSetting handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={6}>
                        <InvoiceSetting handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={7}>
                        <DocumentNumbringFormateList handlePreviousBtn={handlePreviousTab} previousBtn={previousTabs} />
                    </TabPanel>
                </Box>

            </Paper> */}
        </>
    )
}

export default SettingsHome;